<template>
  <v-expansion-panel>
    <v-expansion-panel-header color="#007BC3">
      <template v-slot:actions>
        <v-icon color="white" class="font-weight-black"> icon-up-arrow </v-icon>
      </template>
      <b class="white--text">APROVAR O CADASTRO NO RM</b>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-6">
      <v-row>
        <v-col>
          <label for="row">Aprovado?</label>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Aprovado?"
          >
            <v-radio-group
              :disabled="view"
              @change="sendStatus"
              v-model="form.status_register"
              row
              :error-messages="errors"
            >
              <v-radio label="SIM" value="approved"></v-radio>
              <v-radio label="NÃO" value="disapproved"></v-radio>
            </v-radio-group>
          </validation-provider>
        </v-col>
        <v-col cols="12" v-if="form.status_register === 'disapproved'">
          <validation-provider
            v-slot="{ errors }"
            name="Motivo"
            rules="required"
          >
            <v-textarea
              :disabled="view"
              @change="sendStatus"
              v-model="form.note"
              outlined
              :error-messages="errors"
              chips
              small-chips
              label="Motivo *"
            ></v-textarea>
          </validation-provider>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  props: {
    view: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: ""
    },
    comment: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    form: {
      status_register: "",
      note: ""
    }
  }),
  components: {
    ValidationProvider
  },
  mounted() {
    if (this.status === "disapproved") {
      this.form.note = this.comment;
      this.form.status_register = this.status;
    } else if (this.status === "approved") {
      this.form.status_register = this.status;
    }
  },
  methods: {
    sendStatus() {
      this.$emit("setFields", { data: this.form });
    }
  }
};
</script>

<style></style>
